import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userRegisterView" }
const _hoisted_2 = { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"space-between"} }

import { userRegisterUsingPost } from "@/api/userController";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { reactive } from "vue";
import API from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRegisterView',
  setup(__props) {

const router = useRouter();

const form = reactive({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
} as API.UserRegisterRequest);

/**
 * 提交表单
 * @param data
 */
const handleSubmit = async () => {
  const res = await userRegisterUsingPost(form);
  // 跳转：
  if (res.data.code === 0) {
    message.success("注册成功");
    router.push({
      path: "/user/login",
      replace: true,
    });
  } else {
    message.error("注册失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "用户注册", -1)),
    _createVNode(_component_a_form, {
      style: {"max-width":"480px","margin":"0 auto"},
      "label-align": "left",
      "auto-label-width": "",
      model: form,
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userAccount",
          label: "账号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              placeholder: "请输入账号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPassword",
          tooltip: "密码不少于 8 位",
          label: "密码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
              placeholder: "请输入你的密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "checkPassword",
          tooltip: "确认密码不少于 8 位",
          label: "确认密码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.checkPassword) = $event)),
              placeholder: "请输入确认密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            "html-type": "submit",
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("注册", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_a_link, { href: "/user/login" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("老用户登录", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})